// src/utils/date.ts

export function fmt(ts: string): string {
  const d = new Date(ts);
  const yy = String(d.getFullYear()).slice(-2);
  const MM = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${yy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
}

// para forzar el módulo
export {};

/**
 * Tiny helper → "30 s ago" / "4 min ago" / …
 *
 * Pass `debug = true` to dump **all** intermediates to the console.
 */
export function timeAgo(
  value?: string | Date | null,
  debug = false,
): string {
  const dbg = (...m: any[]) => debug && console.debug('[timeAgo]', ...m);
  if (!value) { dbg('no value'); return '—'; }

  /* 1️⃣  normalise ------------------------------------------------------ */
  let dt: Date | null = null;

  if (value instanceof Date) {
    dt = value;
  } else {
    // matches  "xx-xx-xx HH:MM:SS"
    const m = value.match(/^(\d{2})-(\d{2})-(\d{2}) (\d{2}:\d{2}:\d{2})$/);
    if (m) {
      const [ , a, b, c, hms ] = m;

      // candidate 1: dd‑MM‑yy
      const iso1 = `20${c}-${b}-${a}T${hms}`;
      // candidate 2: yy‑MM‑dd
      const iso2 = `20${a}-${b}-${c}T${hms}`;

      const d1 = new Date(iso1);
      const d2 = new Date(iso2);

      // choose the one that is **not** > 24 h in the future
      const now = Date.now();
      const best = [d1, d2]
        .filter(d => !Number.isNaN(d.getTime()))
        .sort((x, y) =>
          Math.abs(now - x.getTime()) - Math.abs(now - y.getTime()))[0];

      dt = best ?? null;
      dbg('raw:', value, '→ iso1', iso1, 'iso2', iso2, 'chosen', dt?.toISOString());
    } else {
      // other strings: swap space→T if needed
      dt = new Date(value.includes(' ') && !value.includes('T')
        ? value.replace(' ', 'T') : value);
    }
  }

  if (!dt || Number.isNaN(dt.getTime())) { dbg('❌ invalid'); return '—'; }

  /* 2️⃣  diff ----------------------------------------------------------- */
  const diff = Math.floor((Date.now() - dt.getTime()) / 1_000);
  if (diff < 0)               return '—';
  if (diff < 60) {
    /* under a minute → SS s */
    return `${diff}s ago`;
  }

  if (diff < 3_600) {
    /* under an hour → MM min SS s */
    const m = Math.floor(diff / 60);
    const s = diff % 60;
    return `${m} min ${s}s ago`;
  }

  if (diff < 86_400) {
    /* under 24 h → HH hr MM min */
    const h = Math.floor(diff / 3_600);
    const m = Math.floor((diff % 3_600) / 60);
    return `${h} hr ${m} min ago`;
  }
  return `${Math.floor(diff/86_400)} d ago`;
}